
<app-side-menu [(isExpanded)]="isExpanded">
<app-side-menu-title>
	<span class="mat-title-medium">{{"Sonderzeit" | translate : "label-special-time"}}</span>
</app-side-menu-title>
<app-side-menu-content>
	<app-side-menu-group>
		<app-side-menu-group-title>
			{{"Art der Sonderzeit" | translate : "label-special-time-type"}}
		</app-side-menu-group-title>
		<app-side-menu-group-content>
			<mat-radio-group [value]="selectedSpecialTimeType()" (change)="changeSpecialTimeType($event)">
				<mat-radio-button value="opening">{{"Sonderöffnungszeit" | translate : "label-special-opening-time"}}</mat-radio-button>
				<mat-radio-button value="closing">{{"Sonderschließzeit" | translate : "label-special-closing-time"}}</mat-radio-button>
			</mat-radio-group>
		</app-side-menu-group-content>
	</app-side-menu-group>
	<app-side-menu-group >
		<app-side-menu-group-title>
			{{"Zeitraum" | translate : "label-special-time-period"}}
		</app-side-menu-group-title>
		<app-side-menu-group-content>
			<form appDirtyCheck [formGroup]="form" (submit)="submit()">
					<mat-radio-group [value]="selectedDateType()" (change)="changeDateType($event)">
				<mat-radio-button value="single" [disabled]="true">{{"Datum" | translate : "action-date"}}</mat-radio-button>
				<mat-radio-button value="timespan" [disabled]="true">{{"Zeitraum" | translate : "action-timespan"}}</mat-radio-button>
			</mat-radio-group>
			@if(selectedDateType() === "timespan"){
				<mat-form-field>
						<mat-label>{{"Datum" | translate : "input-date"}}</mat-label>
						<mat-date-range-input [rangePicker]="picker" appLocalizedDatepicker>
								<input matStartDate placeholder="Start date" formControlName="startDate">
								<input matEndDate placeholder="End date" formControlName="endDate">
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker" />
						<mat-date-range-picker #picker />
				</mat-form-field>
			}
			@else {
				<mat-form-field>
					<mat-label>{{"Datum" | translate : "input-date"}}</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="startDate">
					<mat-datepicker-toggle matIconSuffix [for]="picker" />
					<mat-datepicker #picker />
				</mat-form-field>
			}
			<mat-radio-group [value]="selectedTimeType()" (change)="changeTimeType($event)">
				<mat-radio-button value="whole-day">{{"Durchgehend (24 Std.)" | translate : "action-permanently-open"}}</mat-radio-button>
				<mat-radio-button value="timespan">{{"Bestimmte Uhrzeit (gilt für jeden Tag)" | translate : "action-specific-time"}}</mat-radio-button>
			</mat-radio-group>
			@if(selectedTimeType() === "timespan"){
				<section class="special-times-menu__time-selection">
          <app-time-input [control]="form.controls.startTime" >
            <span class="label">{{ "Von" | translate: "label-opening-times-range-input-from" : "feature/project/project-opening-times" }}</span>
          </app-time-input>
          <app-time-input [control]="form.controls.endTime">
            <span class="label">{{ "Bis" | translate: "label-opening-times-range-input-to" : "feature/project/project-opening-times" }}</span>
          </app-time-input>
				</section>
			}
			<mat-form-field>
				<mat-label>{{"Anmerkung" | translate : "input-note"}}</mat-label>
				<textarea matInput
														cdkTextareaAutosize
														#autosize="cdkTextareaAutosize"
														cdkAutosizeMinRows="1"
														cdkAutosizeMaxRows="4"
														formControlName="note"></textarea>
			</mat-form-field>
				<section class="special-times-menu__operators">
					<button mat-button class="button--tertiary" type="submit" [disabled]="!form.valid || !form.dirty">
						@if(editSpecialTime()){
							{{"Änderungen Speichern" | translate : "action-add-holidays"}}
						}
						@else {
							{{"Hinzufügen" | translate : "add": "global"}}
						}
					</button>
					<button mat-button type="button" (click)="cancel()">
						{{"Abbrechen" | translate : "cancel": "global"}}
					</button>
			</section>
		</form>
	</app-side-menu-group-content>
</app-side-menu-group>
@if(editSpecialTime()){
	<app-delete-button appInlineConfirmationTrigger #trigger="appInlineConfirmationTrigger"/>
	<app-inline-delete-confirmation [trigger]="trigger" (confirm)="_delete()" [(isOpen)]="isDeleteConfirmationOpen"/>
}
</app-side-menu-content>
</app-side-menu>
